export async function getNotifications() {
    return new Promise(function (resolve, reject) {
        http.get('api/notifications/list')
            .then(response => {
                resolve(response.data);
            }, error => {
                reject(error);
            });
    });
}
